import { Tag } from './tag';

export class DetailedTag extends Tag
{
}
